import { Button, makeStyles } from '@material-ui/core';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { App } from './App';
import { statusColors } from './Constants/constants';

const useStyles = makeStyles({
  snackbarInfo: {
    backgroundColor: `${statusColors.info} !important`
  },
  snackbarSuccess: {
    backgroundColor: `${statusColors.good} !important`
  },
  snackbarDismiss: {
    color: '#ffffff'
  }
});

export default function AppWrapper({ currTheme, toggleTheme }) {
  let { t } = useTranslation();
  const classes = useStyles();
  const notistackRef = React.useRef();
  const onClickDissmiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  return (
    <SnackbarProvider
      maxSnack={3}
      ref={notistackRef}
      classes={{
        variantInfo: classes.snackbarInfo,
        variantSuccess: classes.snackbarSuccess
      }}
      action={(key) => (
        <Button className={classes.snackbarDismiss} onClick={onClickDissmiss(key)}>
          {t('dismiss')}
        </Button>
      )}
    >
      <App currTheme={currTheme} toggleTheme={toggleTheme} />
    </SnackbarProvider>
  );
}
